import useSWR from 'swr';
import { useUserProfile } from '@hooks/user';
import type { SteadioApiError } from '@steadioTypes/common';

export type LikedPostUUIDs = Array<string>;

export default function useFetchUserLikedPostUUIDs() {
  const { userProfile } = useUserProfile();
  const {
    data: userLikedPostUUIDs,
    error,
    mutate,
  } = useSWR<LikedPostUUIDs, SteadioApiError>(
    !!userProfile && '/api/v1/creator/post/liked/ids',
  );

  return {
    userLikedPostUUIDs,
    error,
    loading: !userLikedPostUUIDs && !error,
    mutate,
  };
}
